import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["id"],
    _excluded2 = ["id"],
    _excluded3 = ["id", "disabled"];

var _de;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import B, { Fragment as G, createContext as V, createRef as N, useContext as X, useEffect as $, useMemo as P, useReducer as q, useRef as H } from "react";
import { match as K } from '../../utils/match.js';
import { forwardRefWithAs as v, render as x, Features as j } from '../../utils/render.js';
import { disposables as L } from '../../utils/disposables.js';
import { useDisposables as Q } from '../../hooks/use-disposables.js';
import { useIsoMorphicEffect as h } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as D } from '../../hooks/use-sync-refs.js';
import { useId as k } from '../../hooks/use-id.js';
import { Keys as d } from '../keyboard.js';
import { Focus as y, calculateActiveIndex as z } from '../../utils/calculate-active-index.js';
import { isDisabledReactIssue7711 as Y } from '../../utils/bugs.js';
import { isFocusableElement as Z, FocusableMode as ee, sortByDomNode as te, Focus as W, focusFrom as ne, restoreFocusIfNecessary as J } from '../../utils/focus-management.js';
import { useOutsideClick as re } from '../../hooks/use-outside-click.js';
import { useTreeWalker as oe } from '../../hooks/use-tree-walker.js';
import { useOpenClosed as ae, State as C, OpenClosedProvider as se } from '../../internal/open-closed.js';
import { useResolveButtonType as ie } from '../../hooks/use-resolve-button-type.js';
import { useOwnerDocument as ue } from '../../hooks/use-owner.js';
import { useEvent as T } from '../../hooks/use-event.js';
import { useTrackedPointer as le } from '../../hooks/use-tracked-pointer.js';

var pe = function (r) {
  return r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r;
}(pe || {}),
    ce = function (r) {
  return r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r;
}(ce || {}),
    me = function (a) {
  return a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a;
}(me || {});

function w(e) {
  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (r) {
    return r;
  };
  var r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null,
      i = te(u(e.items.slice()), function (t) {
    return t.dataRef.current.domRef.current;
  }),
      s = r ? i.indexOf(r) : null;
  return s === -1 && (s = null), {
    items: i,
    activeItemIndex: s
  };
}

var de = (_de = {}, _defineProperty(_de, 1, function _(e) {
  return e.menuState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeItemIndex: null,
    menuState: 1
  });
}), _defineProperty(_de, 0, function _(e) {
  return e.menuState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    menuState: 0
  });
}), _defineProperty(_de, 2, function _(e, u) {
  var s;
  var r = w(e),
      i = z(u, {
    resolveItems: function resolveItems() {
      return r.items;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return r.activeItemIndex;
    },
    resolveId: function resolveId(t) {
      return t.id;
    },
    resolveDisabled: function resolveDisabled(t) {
      return t.dataRef.current.disabled;
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
    searchQuery: "",
    activeItemIndex: i,
    activationTrigger: (s = u.trigger) != null ? s : 1
  });
}), _defineProperty(_de, 3, function _(e, u) {
  var i = e.searchQuery !== "" ? 0 : 1,
      s = e.searchQuery + u.value.toLowerCase(),
      o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + i).concat(e.items.slice(0, e.activeItemIndex + i)) : e.items).find(function (l) {
    var m;
    return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(s)) && !l.dataRef.current.disabled;
  }),
      a = o ? e.items.indexOf(o) : -1;
  return a === -1 || a === e.activeItemIndex ? _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: s
  }) : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: s,
    activeItemIndex: a,
    activationTrigger: 1
  });
}), _defineProperty(_de, 4, function _(e) {
  return e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: "",
    searchActiveItemIndex: null
  });
}), _defineProperty(_de, 5, function _(e, u) {
  var r = w(e, function (i) {
    return [].concat(_toConsumableArray(i), [{
      id: u.id,
      dataRef: u.dataRef
    }]);
  });
  return _objectSpread(_objectSpread({}, e), r);
}), _defineProperty(_de, 6, function _(e, u) {
  var r = w(e, function (i) {
    var s = i.findIndex(function (t) {
      return t.id === u.id;
    });
    return s !== -1 && i.splice(s, 1), i;
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
    activationTrigger: 1
  });
}), _de),
    U = V(null);
U.displayName = "MenuContext";

function F(e) {
  var u = X(U);

  if (u === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, F), r;
  }

  return u;
}

function fe(e, u) {
  return K(u.type, de, e, u);
}

var Te = G;

function ye(e, u) {
  var _K;

  var r = q(fe, {
    menuState: 1,
    buttonRef: N(),
    itemsRef: N(),
    items: [],
    searchQuery: "",
    activeItemIndex: null,
    activationTrigger: 1
  }),
      _r = _slicedToArray(r, 2),
      _r$ = _r[0],
      i = _r$.menuState,
      s = _r$.itemsRef,
      t = _r$.buttonRef,
      o = _r[1],
      a = D(u);

  re([t, s], function (g, A) {
    var I;
    o({
      type: 1
    }), Z(A, ee.Loose) || (g.preventDefault(), (I = t.current) == null || I.focus());
  }, i === 0);
  var l = T(function () {
    o({
      type: 1
    });
  }),
      m = P(function () {
    return {
      open: i === 0,
      close: l
    };
  }, [i, l]),
      M = e,
      f = {
    ref: a
  };
  return B.createElement(U.Provider, {
    value: r
  }, B.createElement(se, {
    value: K(i, (_K = {}, _defineProperty(_K, 0, C.Open), _defineProperty(_K, 1, C.Closed), _K))
  }, x({
    ourProps: f,
    theirProps: M,
    slot: m,
    defaultTag: Te,
    name: "Menu"
  })));
}

var Ie = "button";

function Me(e, u) {
  var I;

  var r = k(),
      _e$id = e.id,
      i = _e$id === void 0 ? "headlessui-menu-button-".concat(r) : _e$id,
      s = _objectWithoutProperties(e, _excluded),
      _F = F("Menu.Button"),
      _F2 = _slicedToArray(_F, 2),
      t = _F2[0],
      o = _F2[1],
      a = D(t.buttonRef, u),
      l = Q(),
      m = T(function (p) {
    switch (p.key) {
      case d.Space:
      case d.Enter:
      case d.ArrowDown:
        p.preventDefault(), p.stopPropagation(), o({
          type: 0
        }), l.nextFrame(function () {
          return o({
            type: 2,
            focus: y.First
          });
        });
        break;

      case d.ArrowUp:
        p.preventDefault(), p.stopPropagation(), o({
          type: 0
        }), l.nextFrame(function () {
          return o({
            type: 2,
            focus: y.Last
          });
        });
        break;
    }
  }),
      M = T(function (p) {
    switch (p.key) {
      case d.Space:
        p.preventDefault();
        break;
    }
  }),
      f = T(function (p) {
    if (Y(p.currentTarget)) return p.preventDefault();
    e.disabled || (t.menuState === 0 ? (o({
      type: 1
    }), l.nextFrame(function () {
      var R;
      return (R = t.buttonRef.current) == null ? void 0 : R.focus({
        preventScroll: !0
      });
    })) : (p.preventDefault(), o({
      type: 0
    })));
  }),
      g = P(function () {
    return {
      open: t.menuState === 0
    };
  }, [t]),
      A = {
    ref: a,
    id: i,
    type: ie(e, t.buttonRef),
    "aria-haspopup": "menu",
    "aria-controls": (I = t.itemsRef.current) == null ? void 0 : I.id,
    "aria-expanded": e.disabled ? void 0 : t.menuState === 0,
    onKeyDown: m,
    onKeyUp: M,
    onClick: f
  };

  return x({
    ourProps: A,
    theirProps: s,
    slot: g,
    defaultTag: Ie,
    name: "Menu.Button"
  });
}

var ge = "div",
    Re = j.RenderStrategy | j.Static;

function Ae(e, u) {
  var R, E;

  var r = k(),
      _e$id2 = e.id,
      i = _e$id2 === void 0 ? "headlessui-menu-items-".concat(r) : _e$id2,
      s = _objectWithoutProperties(e, _excluded2),
      _F3 = F("Menu.Items"),
      _F4 = _slicedToArray(_F3, 2),
      t = _F4[0],
      o = _F4[1],
      a = D(t.itemsRef, u),
      l = ue(t.itemsRef),
      m = Q(),
      M = ae(),
      f = function () {
    return M !== null ? (M & C.Open) === C.Open : t.menuState === 0;
  }();

  $(function () {
    var n = t.itemsRef.current;
    n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
      preventScroll: !0
    });
  }, [t.menuState, t.itemsRef, l]), oe({
    container: t.itemsRef.current,
    enabled: t.menuState === 0,
    accept: function accept(n) {
      return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(n) {
      n.setAttribute("role", "none");
    }
  });
  var g = T(function (n) {
    var S, O;

    switch (m.dispose(), n.key) {
      case d.Space:
        if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
          type: 3,
          value: n.key
        });

      case d.Enter:
        if (n.preventDefault(), n.stopPropagation(), o({
          type: 1
        }), t.activeItemIndex !== null) {
          var c = t.items[t.activeItemIndex].dataRef;
          (O = (S = c.current) == null ? void 0 : S.domRef.current) == null || O.click();
        }

        J(t.buttonRef.current);
        break;

      case d.ArrowDown:
        return n.preventDefault(), n.stopPropagation(), o({
          type: 2,
          focus: y.Next
        });

      case d.ArrowUp:
        return n.preventDefault(), n.stopPropagation(), o({
          type: 2,
          focus: y.Previous
        });

      case d.Home:
      case d.PageUp:
        return n.preventDefault(), n.stopPropagation(), o({
          type: 2,
          focus: y.First
        });

      case d.End:
      case d.PageDown:
        return n.preventDefault(), n.stopPropagation(), o({
          type: 2,
          focus: y.Last
        });

      case d.Escape:
        n.preventDefault(), n.stopPropagation(), o({
          type: 1
        }), L().nextFrame(function () {
          var c;
          return (c = t.buttonRef.current) == null ? void 0 : c.focus({
            preventScroll: !0
          });
        });
        break;

      case d.Tab:
        n.preventDefault(), n.stopPropagation(), o({
          type: 1
        }), L().nextFrame(function () {
          ne(t.buttonRef.current, n.shiftKey ? W.Previous : W.Next);
        });
        break;

      default:
        n.key.length === 1 && (o({
          type: 3,
          value: n.key
        }), m.setTimeout(function () {
          return o({
            type: 4
          });
        }, 350));
        break;
    }
  }),
      A = T(function (n) {
    switch (n.key) {
      case d.Space:
        n.preventDefault();
        break;
    }
  }),
      I = P(function () {
    return {
      open: t.menuState === 0
    };
  }, [t]),
      p = {
    "aria-activedescendant": t.activeItemIndex === null || (R = t.items[t.activeItemIndex]) == null ? void 0 : R.id,
    "aria-labelledby": (E = t.buttonRef.current) == null ? void 0 : E.id,
    id: i,
    onKeyDown: g,
    onKeyUp: A,
    role: "menu",
    tabIndex: 0,
    ref: a
  };
  return x({
    ourProps: p,
    theirProps: s,
    slot: I,
    defaultTag: ge,
    features: Re,
    visible: f,
    name: "Menu.Items"
  });
}

var be = G;

function Ee(e, u) {
  var r = k(),
      _e$id3 = e.id,
      i = _e$id3 === void 0 ? "headlessui-menu-item-".concat(r) : _e$id3,
      _e$disabled = e.disabled,
      s = _e$disabled === void 0 ? !1 : _e$disabled,
      t = _objectWithoutProperties(e, _excluded3),
      _F5 = F("Menu.Item"),
      _F6 = _slicedToArray(_F5, 2),
      o = _F6[0],
      a = _F6[1],
      l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === i : !1,
      m = H(null),
      M = D(u, m);

  h(function () {
    if (o.menuState !== 0 || !l || o.activationTrigger === 0) return;
    var c = L();
    return c.requestAnimationFrame(function () {
      var b, _;

      (_ = (b = m.current) == null ? void 0 : b.scrollIntoView) == null || _.call(b, {
        block: "nearest"
      });
    }), c.dispose;
  }, [m, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  var f = H({
    disabled: s,
    domRef: m
  });
  h(function () {
    f.current.disabled = s;
  }, [f, s]), h(function () {
    var c, b;
    f.current.textValue = (b = (c = m.current) == null ? void 0 : c.textContent) == null ? void 0 : b.toLowerCase();
  }, [f, m]), h(function () {
    return a({
      type: 5,
      id: i,
      dataRef: f
    }), function () {
      return a({
        type: 6,
        id: i
      });
    };
  }, [f, i]);
  var g = T(function () {
    a({
      type: 1
    });
  }),
      A = T(function (c) {
    if (s) return c.preventDefault();
    a({
      type: 1
    }), J(o.buttonRef.current);
  }),
      I = T(function () {
    if (s) return a({
      type: 2,
      focus: y.Nothing
    });
    a({
      type: 2,
      focus: y.Specific,
      id: i
    });
  }),
      p = le(),
      R = T(function (c) {
    return p.update(c);
  }),
      E = T(function (c) {
    p.wasMoved(c) && (s || l || a({
      type: 2,
      focus: y.Specific,
      id: i,
      trigger: 0
    }));
  }),
      n = T(function (c) {
    p.wasMoved(c) && (s || l && a({
      type: 2,
      focus: y.Nothing
    }));
  }),
      S = P(function () {
    return {
      active: l,
      disabled: s,
      close: g
    };
  }, [l, s, g]);
  return x({
    ourProps: {
      id: i,
      ref: M,
      role: "menuitem",
      tabIndex: s === !0 ? void 0 : -1,
      "aria-disabled": s === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: A,
      onFocus: I,
      onPointerEnter: R,
      onMouseEnter: R,
      onPointerMove: E,
      onMouseMove: E,
      onPointerLeave: n,
      onMouseLeave: n
    },
    theirProps: t,
    slot: S,
    defaultTag: be,
    name: "Menu.Item"
  });
}

var Se = v(ye),
    Pe = v(Me),
    ve = v(Ae),
    xe = v(Ee),
    ot = Object.assign(Se, {
  Button: Pe,
  Items: ve,
  Item: xe
});
export { ot as Menu };